import * as React from "react";
import { createContext, Provider, use } from "react";

import {
  ApiRequestCachingStore,
  BreakpointStore,
  BudgetStore,
  ChatStore,
  GlobalErrorsStore,
  ImageGenerationStore,
  NavigationStore,
  SettingsStore,
  SidebarStore,
  StreamingChatStore,
  SummaryStore,
  ThreadStore,
  TranscriptionStore,
  UserStore,
  WhitelabelStore,
} from ".";
import GlossaryStore from "./GlossaryStore";
import { PermissionStore } from "./PermissionStore";
import { ToastStore } from "./ToastStore";
import TranslationStore from "./TranslationStore";

export interface IStoreContext {
  breakpointStore: BreakpointStore;
  budgetStore: BudgetStore;
  chatStore: ChatStore;
  globalErrorsStore: GlobalErrorsStore;
  navigationStore: NavigationStore;
  settingsStore: SettingsStore;
  sidebarStore: SidebarStore;
  streamingChatStore: StreamingChatStore;
  summaryStore: SummaryStore;
  threadStore: ThreadStore;
  imageGenerationStore: ImageGenerationStore;
  transcriptionStore: TranscriptionStore;
  userStore: UserStore;
  permissionStore: PermissionStore;
  toastStore: ToastStore;
  translationStore: TranslationStore;
  glossaryStore: GlossaryStore;
  whitelabelStore: WhitelabelStore;
  apiRequestCachingStore: ApiRequestCachingStore;
}

export const store: IStoreContext = {
  breakpointStore: new BreakpointStore(),
  budgetStore: new BudgetStore(),
  chatStore: new ChatStore(),
  globalErrorsStore: new GlobalErrorsStore(),
  navigationStore: new NavigationStore(),
  settingsStore: new SettingsStore(),
  sidebarStore: new SidebarStore(),
  streamingChatStore: new StreamingChatStore(),
  summaryStore: new SummaryStore(),
  threadStore: new ThreadStore(),
  imageGenerationStore: new ImageGenerationStore(),
  transcriptionStore: new TranscriptionStore(),
  userStore: new UserStore(),
  permissionStore: new PermissionStore(),
  toastStore: new ToastStore(),
  translationStore: new TranslationStore(),
  glossaryStore: new GlossaryStore(),
  whitelabelStore: new WhitelabelStore(),
  apiRequestCachingStore: new ApiRequestCachingStore(),
};

let StoreContext: React.Context<IStoreContext> | undefined;
let storeContextProvider: React.Provider<IStoreContext> | undefined;

const getStoreContext = (): React.Context<IStoreContext> => {
  if (!StoreContext) {
    StoreContext = createContext(store);
  }

  return StoreContext;
};

export const getStoreContextProvider = (): Provider<IStoreContext> => {
  if (!storeContextProvider) {
    storeContextProvider = getStoreContext().Provider;
  }

  return storeContextProvider;
};

export function useStore(): IStoreContext {
  return use(getStoreContext());
}
